module.exports = __webpack_public_path__ + "img/cho_chang.a31a6ad5.jpg";